import { usePeriod } from '../context/PeriodContext';

const PeriodToolbar: React.FC = () => {
  const { dueDate, setDueDate } = usePeriod();

  return (
    <div className="period-toolbar">
      <label>
        Due Date
        <input
          type="date"
          value={dueDate}
          onChange={(e) => setDueDate(e.target.value)}
        />
      </label>
    </div>
  );
};

export default PeriodToolbar;
